import React from 'react'
import CreateAssetServiceTicket from '../PureComponent/CreateAssetServiceTicket'

const RenderCreateAssetServiceTicket = () => {
  return (
<CreateAssetServiceTicket/>
  )
}

export default RenderCreateAssetServiceTicket